<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 md10 offset-md1>
   			<v-card>
	   			<v-card-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px" v-if="hasCreateAccess">
              <v-btn slot="activator" round color="primary" dark small class="ml-4">Add New</v-btn>
              <v-form v-model="validForm">
                <v-card>
                  <v-card-title>
                    <span class="headline" v-text="item.id ? 'Update Head Office' : 'Add Head Office'"></span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md py-0>
                      <v-layout wrap>
                        <v-flex xs12 sm6>
                          <v-text-field :rules="nameRules" counter="50" v-model="item.title" label="Head Office Name"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field :rules="gstRules" counter="15" maxlength="15" v-model="item.gst_number" label="GST Number"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field :rules="phoneRules" mask="#### #### ###" counter="12" v-model="item.phone" label="Phone"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field :rules="emailRules" counter="50" v-model="item.email" label="Email"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field counter="100" v-model="item.address1" label="Address 1"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field counter="100" v-model="item.address2" label="Address 2"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field counter="6" type="number" v-model="item.pincode" label="Pincode"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-autocomplete :rules="requireRule" v-model="item.country" :items="countries" item-text="country" item-value="id" label="Country"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-autocomplete :rules="requireRule" v-model="item.state" :items="states" item-text="state" item-value="id" label="State"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-autocomplete :rules="requireRule" v-model="item.city" :items="cities" item-text="city" item-value="id" label="City"></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="item.id ? updateItem() : addItem()" v-text="item.id ? 'Update' : 'Save'"></v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="distributors"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <td>{{ props.item.title }}</td>
              <td>{{ props.item.gst_number }}</td>
              <td>{{ props.item.city_name }}</td>
              <td>{{ props.item.state_name }}</td>
              <td>{{ props.item.country_name }}</td>
              <td>{{ props.item.phone }}</td>
              <td class="align-center justify-center layout px-0">
                <edit-btn :item="props.item" />
                <delete-btn :item="props.item" />
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !distributors.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(distributors)" />

			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'Distributors',
    data () {
      return {
        model: 'distributor',
      	title: "Distributors",
        validForm: false,
      	processing: false,
        dialog: false,
        deleteDialog: false,
        states: [],
        cities: [],
      	distributors: [],
        headers: [
          { text: 'Branch Name', value: 'title'},
          { text: 'GST Number', value: 'gst_number'},
          { text: 'City', value: 'city_name'},
          { text: 'State', value: 'state_name'},
          { text: 'Country', value: 'country_name'},
          { text: 'Phone', value: 'phone'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        defaultItem: {
          id: "",
          title: "",
          city: "",
          state: "",
          country: this.getDefault('country'),
          gst_number: "",
          phone: "",
          email: "",
          is_active: false,
          is_deleted: false,
          address1: "",
          address2: "",
          pincode: ""
        },
        nameRules: [
            v => !!v || 'Name is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        emailRules: [
            v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
            v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        phoneRules: [
            v => !!v || 'Phone Number is required',
            v => v && v.length >= 11 || 'Must be 11 characters',
            v => v && v.length <= 12 || 'Maximum 12 characters allowed'
        ],
        requireRule: [
          v => !!v || 'Field is required'
        ],
        gstRules: [
          v => /^(([0-9]{2})([A-Z0-9]{10})([A-Z0-9]{1})Z([0-9]{1}))$/.test(v) || 'GST number must be valid'
        ]
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Head Offices',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Head Offices')
    },
    methods: {

      loadPage () {
        this.processing = true
        this.axios.get(this.config.apis.getDistributors.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage))
          .then((response) => {
            this.processing = false
            if (response && response.data && response.data.success && response.data.data && response.data.data.items) {
            	this.distributors = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.distributors = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      getCities (state) {
        this.processing = true
        this.cities = []
        this.axios.get(this.config.apis.getCitiesByState.replace(":state", state))
        .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.cities = response.data.data
            }
        })
        .catch((error) => {
            this.processing = false
        })
      },
      addItem () {
        this.processing = true
        this.axios.post(this.config.apis.addDistributor, this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let new_item = Object.assign({}, this.item)
              new_item.id = response.data.data.id

              let country = this.countries.filter( v => v.id == new_item.country )

              new_item.country_name = country ? country[0].country : ""

              let state = this.states.filter( v => v.id == new_item.state )

              new_item.state_name = state ? state[0].state : ""

              let city = this.cities.filter( v => v.id == new_item.city )

              new_item.city_name = city ? city[0].city : ""

              this.distributors.unshift(new_item)

              this.notifySuccess('insertSuccess')
              this.close()
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.close()
          })
      },
      updateItem () {
      	this.processing = true
        this.axios.put(this.config.apis.updateDistributor.replace(":id", this.item.id), this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              let country = this.countries.filter( v => v.id == this.item.country )

              this.item.country_name = country ? country[0].country : ""

              let state = this.states.filter( v => v.id == this.item.state )

              this.item.state_name = state ? state[0].state : ""

              let city = this.cities.filter( v => v.id == this.item.city )

              this.item.city_name = city ? city[0].city : ""

              this.notifySuccess('updateSuccess')
              this.close()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      editItem (item) {
        this.item = item
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
        }, 300)
      }

    },
    mounted () {
      this.getCountries()
      this.item = this.extend({}, this.defaultItem)
    },

    computed: {

    },

    watch: {

        'item.country': function(val, oldVal){
            if (val && val != oldVal) {
              this.getStatesByCountry(val).then( states => {
                this.states = states
              })
            }
        },
        'item.state': function(val, oldVal){
            if (val && val != oldVal) {
                this.getCities(val)
            }
        }
    }

  }
</script>
